import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface AuthState {
  token: string | null
  isAuthenticated: boolean | null
  user: any | null // You can improve this type based on the shape of your `user` object
}

// Initial state with conditional localStorage access
const initialState: AuthState = {
  token: typeof window !== 'undefined' ? localStorage.getItem('token') : null,
  isAuthenticated: typeof window !== 'undefined' ? !!localStorage.getItem('token') : null,
  user:
    typeof window !== 'undefined' && localStorage.getItem('ko_user')
      ? JSON.parse(localStorage.getItem('ko_user') as string)
      : null,
}

// Create auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string; user: any }>) => {
      console.log('login action', action.payload)
      localStorage.setItem('token', action.payload.token)
      localStorage.setItem('ko_user', JSON.stringify(action.payload.user))
      state.token = action.payload.token
      state.isAuthenticated = true
      state.user = action.payload.user
    },
    logout: (state) => {
      localStorage.removeItem('token')
      localStorage.removeItem('ko_user')
      state.token = null
      state.isAuthenticated = false
      state.user = null
    },
    updateUser: (state, action: PayloadAction<AuthState['user']>) => {
      localStorage.setItem('ko_user', JSON.stringify(action.payload))
      state.user = action.payload
    },
  },
})

// Export actions
export const { login, logout, updateUser } = authSlice.actions

// Selectors
export const selectToken = (state: { auth: AuthState }) => state.auth.token
export const selectIsAuthenticated = (state: { auth: AuthState }) => state.auth.isAuthenticated
export const selectUser = (state: { auth: AuthState }) => state.auth.user

// Export reducer
export default authSlice.reducer
